module.exports = __webpack_public_path__ + "img/12_klio_08.09f455fd.jpg";